import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import {
  ApproveResult,
  EmailQueuePage,
  EmailQueueQuery,
  HeldEmailDetail,
} from './email-queue.types';

/** Admin approval queue: email to non-staff that has not gone out. */
@Injectable({ providedIn: 'root' })
export class EmailQueueService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}/api/admin/email-queue`;

  list(query: EmailQueueQuery): Observable<EmailQueuePage> {
    let params = new HttpParams()
      .set('view', query.view)
      .set('page', query.page)
      .set('page_size', query.page_size);
    if (query.q) params = params.set('q', query.q);
    if (query.category) params = params.set('category', query.category);
    return this.http.get<EmailQueuePage>(`${this.base}/`, { params });
  }

  detail(id: string): Observable<HeldEmailDetail> {
    return this.http.get<HeldEmailDetail>(`${this.base}/${id}/`);
  }

  approve(ids: string[]): Observable<ApproveResult> {
    return this.http.post<ApproveResult>(`${this.base}/approve/`, { ids });
  }

  delete(ids: string[]): Observable<{ deleted: number }> {
    return this.http.post<{ deleted: number }>(`${this.base}/delete/`, { ids });
  }

  restore(ids: string[]): Observable<{ restored: number }> {
    return this.http.post<{ restored: number }>(`${this.base}/restore/`, { ids });
  }
}
